import { Account } from '@modules-deprecated/app/accounts/types'

import { AccountFromTemplateForm } from '../types'

export const getUpdateAccountFromTemplateDefaultValues = (account?: Account): AccountFromTemplateForm => ({
  description: account?.description ?? '',
  name: account?.name ?? '',
})
